module.exports = __webpack_public_path__ + "static/img/logo_ryy.89f05cf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo_ryy.png
// module id = 981
// module chunks = 1